export const FETCH_CALENDAR_LINK = 'FETCH_CALENDAR_LINK';
export const FETCH_CALENDAR_LINK_SUCCESS = 'FETCH_CALENDAR_LINK_SUCCESS';
export const FETCH_CALENDAR_LINK_FAILURE = 'FETCH_CALENDAR_LINK_FAILURE';
